import PurchaseRequestRecordSelector from "@/components/PurchaseRequest/PurchaseRequestRecordSelector";
import { useModalBehavior } from "@/hooks/behaviors";
import { SrmPurchaseRequestVo } from "@/types/apis";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

type Props = {
  onSelect?: (rows?: SrmPurchaseRequestVo[]) => void;
};

export const SearchPurchaseRequest = ({ onSelect }: Props) => {
  const { t } = useTranslation("inquiryManagement");
  const { open, openModal, closeModal } = useModalBehavior();

  const handleOk = (rows?: SrmPurchaseRequestVo[]) => {
    closeModal();
    if (rows && rows.length > 0) {
      onSelect?.(rows);
    }
  };

  return (
    <>
      <Button
        style={{
          marginLeft: 10,
          marginBottom: 10,
        }}
        type="primary"
        onClick={() => openModal()}
      >
        {t("添加")}
      </Button>

      <PurchaseRequestRecordSelector
        selectionMode="multiple"
        open={open}
        onOk={handleOk}
        onClose={closeModal}
      />
    </>
  );
};
